<div class="appraisee">
    <div (click)="isToggle = !isToggle" class="head">
        Appraisee
        <i class="fa"
           [class.fa-caret-down]="isToggle"
           [class.fa-caret-up]="!isToggle"></i>
    </div>
    <div [collapse]="isToggle">
        <div class="head-list m-t-20">
            <div>
                Type of selection of respondents
            </div>
            <div class="type-appraisee" *ngIf="process.appraiseeEmployeeTypes">
                <span>
                    <input [ngModel]="proffStaff" (click)="toggleEmployeeType(employeeType.ProfessionalStaff)" id="proff-staff" type="checkbox">
                    <label for="proff-staff">CF staff</label>
                </span>
                <span>
                    <input [ngModel]="supporStaff"  (click)="toggleEmployeeType(employeeType.SupportStaff)" id="central-services" type="checkbox">
                    <label for="central-services">Non-CF staff</label>
                </span>
            </div>
        </div>
      <app-employee-selection *ngIf="process.appraiseeSearchSettings" [isTypeFilterEnabled]="true" [employeeTypes]="process.appraiseeEmployeeTypes" [employeeSelectionSettings]="process.appraiseeSearchSettings"></app-employee-selection>
      </div>
  </div>